var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.attending)?_c('v-chip',{staticClass:"font-weight-medium",staticStyle:{"cursor":"pointer"},attrs:{"color":"primary"},on:{"click":_vm.handleClick}},[_c('div',{staticClass:"mr-2 d-none d-sm-flex"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('AttendingChronometer')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }